/** On a phone the admin left menu is a drawer. Show it first, then the page. */

export const COMPACT_SIDEBAR_MQ = "(max-width: 800px)";

const MENU_COPY = {
  "admin-nav-dashboard": {
    titleKey: "tour_admin_menu_dashboard_title",
    bodyKey: "tour_admin_menu_dashboard_body",
  },
  "admin-nav-groups": {
    titleKey: "tour_admin_menu_groups_title",
    bodyKey: "tour_admin_menu_groups_body",
  },
  "admin-nav-invite": {
    titleKey: "tour_admin_menu_invite_title",
    bodyKey: "tour_admin_menu_invite_body",
  },
};

export function shouldUseCompactTourNav() {
  return typeof window !== "undefined" && window.matchMedia(COMPACT_SIDEBAR_MQ).matches;
}

function isAdminNavId(id) {
  return String(id || "").startsWith("admin-nav");
}

export function expandTourSteps(steps, { compactSidebar = false } = {}) {
  if (!compactSidebar || !Array.isArray(steps)) return steps || [];
  const out = [];
  let lastMenuNavId = null;
  for (const step of steps) {
    const navId = step.navTourId;
    const featureId = step.tourId || step.fallbackTourId;
    const canSplit = isAdminNavId(navId) && featureId && featureId !== navId;
    if (!canSplit) {
      out.push(step);
      lastMenuNavId = null;
      continue;
    }
    if (lastMenuNavId !== navId) {
      const copy = MENU_COPY[navId] || {};
      out.push({
        ...step,
        id: `${step.id}-menu`,
        tourId: navId,
        navTourId: navId,
        fallbackTourId: "admin-nav-toggle",
        extraTourIds: undefined,
        arrive: { type: "openPanel", panel: "adminSidebar" },
        doForMe: null,
        closeSidebar: false,
        autoAdvanceAfterSpeech: undefined,
        autoAdvanceMs: undefined,
        silent: false,
        titleKey: copy.titleKey || step.titleKey,
        bodyKey: copy.bodyKey || step.bodyKey,
        requireClick: false,
      });
      lastMenuNavId = navId;
    }
    out.push({
      ...step,
      navTourId: undefined,
      closeSidebar: true,
    });
  }
  return out;
}
